import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';

import { IAmigoGamingServerGame, IAmigoGamingGetUrl } from '../../types/interfaces/Slots/AmigoGaming';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { getTab, gamesOrder } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IAmigoGamingServerGame[]>): ISlotViewItem[] => {
    const games = data
      .map((game: IAmigoGamingServerGame) => ({
        id: game.gameID,
        gameId: game.gameID,
        description: game.typeDescription,
        gameName: game.gameName,
        provider: 'amigogaming',
        routeProvider: 'amigogaming',
        type: CasinoType.slots,
        tab: getTab(game.gameID.toString()),
        imageUrl: `/images/amigogaming/${game.gameID}.png`,
      }))
      .sort(
        (a, b) =>
          (gamesOrder.indexOf(String(a.gameId)) + 1 || Infinity) -
          (gamesOrder.indexOf(String(b.gameId)) + 1 || Infinity - 1),
      );
    return games;
  };

  convertGameUrl = ({ data }: IAmigoGamingGetUrl) => data;
}
export default Converter;
